import { render, staticRenderFns } from "./media-folder.vue?vue&type=template&id=03f42bca&scoped=true&"
import script from "./media-folder.vue?vue&type=script&lang=js&"
export * from "./media-folder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f42bca",
  null
  
)

export default component.exports